export default __webpack_public_path__ + "static/media/fuelEnDetailTruck.e48986eb.jpg";